import { CreateUserWithPasswordLoginDocument, CreateUserWithPasswordLoginMutationVariables } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';
import { invalidateUserList } from '../userListCache';

export function useUserCreate() {
    const createUserMutation = useMutation(CreateUserWithPasswordLoginDocument, { update: invalidateUserList });

    async function create(data: CreateUserWithPasswordLoginMutationVariables) {
        const response = await createUserMutation.mutate(data);
        const result = response?.data?.createUserWithPasswordLogin;
        switch (result?.__typename) {
            case 'CreatedUser':
                return result.id;
            case 'EmailTaken':
                throw new Error(`Could not create user. ${result.message}`);
            default:
                throw new Error('Could not create user. Unknown Error.');
        }
    }

    return {
        createUserMutation,
        create,
    };
}
